<template>
  <div class="transferout">
      <h2>
          {{$t('transferOut')}}
      </h2>
      <div class="content_wrapper">
          <Form :model="takeModel" :rules="rules" class="inputForm" ref="takeForm" >
				<FormItem prop="account">
				  <effect-select :label='$t("takeAccount")' :options="accountList" v-model="takeModel.account"></effect-select>
				</FormItem>
                <FormItem prop="bankId"  >
                    <effect-select :label='$t("takeBank")' :options="bankList" v-model="takeModel.bankId" :disabled='disabled'></effect-select>
                </FormItem>
                <FormItem  prop="amount">
                    <effect-input  :label='$t("takeMoney")'  v-model="takeModel.amount"></effect-input>
                </FormItem>
                <FormItem  >
                    <effect-input :label='$t("currencyType")' :readonly="readonly"  v-model="takeModel.currency"></effect-input>
                    <!-- <p class="withdrawCurrency">{{$t('withdrawCurrency')}}</p> -->
                </FormItem>
            </Form>
			<Button type="primary" class="formBtn"  @click="ok">{{$t('submit')}}</Button>
      </div>
    <loading :isSpinShow="loading"></loading>
  </div>
</template>

<script>
// @ is an alias to /src
import EffectSelect from '@/components/EffectSelect.vue';
import EffectInput from '@/components/EffectInput.vue';
import Loading from '@/components/Loading.vue';


export default {
  name: 'Home',
  components: {
    EffectSelect,
    EffectInput,
    Loading
  },
  data(){
      const validateAmount = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error(this.$t('fieldError')));
                }
				var reg = /^(\d{0,99})(\.(\d{0,2}))?$/g;
				if (!reg.test(value)) {
					callback(new Error(this.$t('amountCheck')));
				} else {
					callback();
				}
				
               
            };
    return{
        takeModel:{
            account:'',
            amount:'',
            bankId:'',
            currency:''
        },
        currencyOptions:[
            {
                value:'USD',
                label:'USD'
            },
            {
                value:'EUR',
                label:'EUR'
            },
            {
                value:'GBP',
                label:'GBP'
            }
        ],
		rules:{
			account:[{
				required: true,
				message: this.$t('fieldError')
			}],
			bankId:[{
				required: true,
				message: this.$t('fieldError')
			}],
			amount:[{
				validator: validateAmount,
				trigger: 'blur'
			}]
		},
		bankList: [],
		accountList:[],
        loading: false,
        readonly: true,
        disabled: true
    }
    
  },
  watch:{ 
      'takeModel.account'(val) {
        //   console.log(this.accountList)
            this.accountList.forEach((item,index) => {
                if(val == item.account){
                    this.takeModel.currency = item.currency
                }
            })
			var common = this.accountList.filter(function (item) 
			{
				return item.account == val && item.bankBindID > 0
			})
			// console.log(common)
			if(common.length > 0){
				this.bankList = []
				let data = {
					value:common[0].bankBindID.toString(),
					label:common[0].bankName
				}
				this.bankList.push(data)
				this.takeModel.bankId = common[0].bankBindID.toString()
			}else{
				this.takeModel.bankId = ""
				this.$refs.takeForm.fields.forEach((v,j) => {
					// console.log(v,j)
					v.validateDisabled = true
					v.validateMessage = ''
					v.validateState = ''
				})
				// this.getBank()
			}
      }
  },
    created(){
        // this.getBank()
        this.getAccount()
    },
    methods:{
        getBank(){
            this.bankList = []
            this.$axios.get('/api/MoneyPay/BankList')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    res.data.obj.forEach(e => {
                        let data = {
                            value:e.id.toString(),
                            label:e.bankName
                        }
                        this.bankList.push(data)
                    });
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => {
                this.$Message.error(err.data.msg)
            })
        },
        getAccount(){
            this.accountList = []
            this.$axios.get('/api/MoneyPay/AccountList')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    res.data.obj.forEach(e => {
                        // let data = {
                        //     value:e.account.toString(),
                        //     label:e.account,
                        //     currency:e.currency
                        // }
                        e.value = e.account.toString(),
                        e.label = e.account
                        this.accountList.push(e)
                    });
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => {
                this.$Message.error(err.data.msg)
            })
        },
        changeAccount(val){

        },
        ok () {
        	this.$refs['takeForm'].validate((valid) => {
        		if (valid) {
                    this.loading = true
                    let data = {
                        "account": Number(this.takeModel.account),
                        "amount": Number(this.takeModel.amount),
                        "bankId": Number(this.takeModel.bankId),
                        "currency": this.takeModel.currency
                    }
        			this.$axios.post('/api/MoneyTake/IssueApplication',data)
        			.then(async (res) => {
        				let dt = res.data
						this.loading = false
        			    if(dt.status == 1){
                            this.$Message.success(dt.msg)
                            this.$refs.takeForm.resetFields();
        			    }else{
        			        this.$Message.error(dt.msg)
        			    }
        			}).catch(() => {
						this.loading = false
					})
        		}
        	})
        },
    }
}
</script>
<style lang="less">
.transferout{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
	.inputForm{
		justify-content: space-between!important;
	}
    .ivu-form-item{
        width: 48%;
    }
	.formBtn{
		min-width: 230px;
	}
	// .ivu-form-item-error {
	// 	.ivu-select-selection{
	// 		border: 1px solid #ed4014!important;
	// 	}
	// }
	.demo-spin-icon-load{
		animation: ani-demo-spin 1s linear infinite;
    }
    .withdrawCurrency{
        position: absolute;
        color: #8b8b8c;
    }
}

@keyframes ani-demo-spin {
	from { transform: rotate(0deg);}
	50%  { transform: rotate(180deg);}
	to   { transform: rotate(360deg);}
}
</style>
